// Portfolio data for Akhil M
export const portfolioData = {
  personal: {
    name: "Akhil M",
    title: "AI Lead & Full-Stack Developer",
    tagline: "Building at the edge of engineering and intelligence. Turning machine knowledge into AI-powered software—one problem at a time.",
    location: "Palakkad, India 🇮🇳",
    email: "akhil.m2k@gmail.com",
    github: "https://github.com/andromechanic",
    linkedin: "https://www.linkedin.com/in/andromechanic",
    bio: "Dynamic professional transitioning from mechanical engineering to programming and AI, with expertise in building software solutions and leveraging AI technologies. Experienced in Python, Java, machine learning, and AI integration, with hands-on experience in web development using JavaScript and Vue.js. A problem solver passionate about developing innovative tools."
  },
  
  education: [
    {
      id: "edu1",
      title: "Pursuing Diploma in Data Science",
      institution: "IIT Madras",
      period: "2024 — 2025",
      description: "Currently pursuing advanced data science education at India's premier technical institute. Learning machine learning algorithms, statistical analysis, data visualization, and big data technologies. Gaining expertise in Python, R, SQL, and modern data science tools.",
      achievements: ["Advanced Machine Learning", "Statistical Analysis", "Big Data Technologies", "Data Visualization"],
      icon: "GraduationCap"
    },
    {
      id: "edu2",
      title: "Diploma in Programming",
      institution: "IIT Madras",
      period: "2023 — 2024",
      description: "Completed comprehensive programming education at IIT Madras. Mastered multiple programming paradigms including object-oriented programming, functional programming, and web development. Built strong foundations in algorithms, data structures, and software engineering principles.",
      achievements: ["Object-Oriented Programming", "Web Development", "Algorithms & Data Structures", "Software Engineering"],
      icon: "Code"
    },
    {
      id: "edu3",
      title: "B.Tech — Mechanical Engineering",
      institution: "APJ Abdul Kalam Technological University",
      period: "2018 — 2022",
      description: "Earned Bachelor's degree in Mechanical Engineering with focus on design, manufacturing, and thermal systems. Developed strong analytical thinking, problem-solving skills, and engineering fundamentals that later transitioned into programming and AI development.",
      achievements: ["Engineering Design", "Manufacturing Processes", "Thermal Systems", "CAD/CAM", "Analytical Thinking"],
      icon: "Cog"
    }
  ],
  
  skills: {
    programming: [
      { name: "Python", level: 95 },
      { name: "JavaScript", level: 80 },
      { name: "Java", level: 70 },
      { name: "C", level: 65 }
    ],
    webDev: ["Vue.js", "Flask", "HTML5", "CSS3", "JavaScript", "SQLite", "Bootstrap"],
    aiMl: [
      { name: "Prompt Engineering", level: 92 },
      { name: "Generative AI", level: 88 },
      { name: "NLP", level: 78 },
      { name: "Fine-tuning LLMs", level: 75 }
    ],
    tools: ["PyTorch", "TensorFlow", "Scikit-Learn", "Streamlit", "OpenAI", "Ollama", "CAD", "Fusion360", "Ansys"]
  },
  
  experience: [
    {
      id: "exp1",
      title: "AI Lead",
      company: "We Guide",
      period: "Jun 2025 — Present",
      status: "ACTIVE",
      description: "Drove the development of a skilled workforce by leading a startup team in delivering intensive, hands-on Python programming training. Delivered technical presentations at educational institutions and partnered with academic bodies to design workshops.",
      icon: "Rocket"
    },
    {
      id: "exp2",
      title: "Technical Lead",
      company: "Technovate",
      period: "Jan 2024 — May 2025",
      description: "Led a team at a startup, mentoring students in Python programming through comprehensive training sessions. Delivered technical talks at various colleges and collaborated with institutions to create workshops.",
      icon: "Users"
    },
    {
      id: "exp3",
      title: "AI Intern",
      company: "Qapp AI",
      period: "Mar 2024 — May 2024",
      description: "Collaborated on contract analysis for Protoripe, leveraging AI and machine learning for document processing and contract data extraction for RAG application.",
      icon: "Brain"
    }
  ],
  
  projects: [
    {
      id: "proj1",
      title: "Library Management System",
      tags: ["Python", "Flask", "Full-Stack"],
      description: "Created a comprehensive full-stack application to manage 1,000+ books with advanced search, borrowing, and inventory features. Achieved 95% user satisfaction rate through intuitive design and robust functionality.",
      tech: ["Python", "Flask", "HTML5", "CSS3", "JavaScript", "SQLite", "Bootstrap"],
      icon: "BookOpen"
    },
    {
      id: "proj2",
      title: "Face Recognition Attendance System",
      tags: ["Computer Vision", "AI", "MTCNN"],
      description: "Full-fledged attendance system using advanced computer vision with MTCNN face detection and InceptionResnetV1 recognition. Automated attendance tracking with high accuracy and real-time processing capabilities.",
      tech: ["Python", "Computer Vision", "MTCNN", "InceptionResnetV1", "Flask", "OpenCV"],
      icon: "ScanFace"
    },
    {
      id: "proj3",
      title: "Influencer Sponsor Platform",
      tags: ["Vue.js", "Full-Stack", "Analytics"],
      description: "Platform connecting 500+ influencers and 200 sponsors with advanced analytics and matching algorithms. Achieved 30% increase in engagement through data-driven recommendations and visualization.",
      tech: ["Vue.js", "JavaScript", "SQLite", "Matplotlib", "Chart.js", "Node.js"],
      icon: "Share2"
    },
    {
      id: "proj4",
      title: "Personal Assistant Bot",
      tags: ["LLM", "AI", "Automation"],
      description: "AI-powered personal assistant reducing scheduling time by 35% using both local and cloud LLMs. Features natural language processing, task automation, and intelligent conversation capabilities.",
      tech: ["Ollama", "OpenAI", "Streamlit", "Python", "NLP", "LangChain"],
      icon: "Bot"
    }
  ]
};

// Level configuration
export const levelConfig = [
  {
    id: 1,
    name: "Education Valley",
    theme: "education",
    gradient: "linear-gradient(to bottom, #7dd3fc, #e0f2fe)",
    groundColor: "#4ade80",
    description: "Where the journey began - Academic foundations",
    items: portfolioData.education,
    npcFacts: [
      "Akhil started as a Mechanical Engineer!",
      "IIT Madras shaped his programming skills",
      "From gears to code - quite a journey!",
      "Now pursuing Data Science at IIT Madras",
      "Mechanical background gives him unique problem-solving skills",
      "Learning ML algorithms and statistical analysis",
      "Mastered object-oriented and functional programming",
      "Built strong foundations in algorithms and data structures"
    ]
  },
  {
    id: 2,
    name: "Skills City",
    theme: "skills",
    gradient: "linear-gradient(to bottom, #fef3c7, #fde68a)",
    groundColor: "#f59e0b",
    description: "Master the tools of the trade",
    items: Object.entries(portfolioData.skills).map(([key, val], i) => ({
      id: `skill${i}`,
      category: key,
      data: val
    })),
    npcFacts: [
      "Python is Akhil's superpower - 95% proficiency!",
      "AI & Machine Learning run in his code",
      "From TensorFlow to OpenAI - he knows them all",
      "92% in Prompt Engineering - masters AI conversations",
      "88% in Generative AI - creates amazing content",
      "Vue.js and Flask are his web development favorites"
    ]
  },
  {
    id: 3,
    name: "Experience Heights",
    theme: "experience",
    gradient: "linear-gradient(to bottom, #1e293b, #475569)",
    groundColor: "#64748b",
    description: "Professional milestones and achievements",
    items: portfolioData.experience,
    npcFacts: [
      "Currently leading AI at We Guide!",
      "Mentored countless Python developers",
      "Built AI solutions for real businesses",
      "Delivered technical talks at educational institutions",
      "Partnered with academic bodies for workshops",
      "From intern to AI Lead in just 1.5 years!"
    ]
  },
  {
    id: 4,
    name: "Project Galaxy",
    theme: "projects",
    gradient: "linear-gradient(to bottom, #312e81, #4c1d95)",
    groundColor: "#8b5cf6",
    description: "Innovations and creations",
    items: portfolioData.projects,
    npcFacts: [
      "Built a Library System for 1000+ books!",
      "Face Recognition with cutting-edge AI",
      "Connected 500+ influencers with sponsors",
      "AI assistant that saves 35% scheduling time",
      "From mechanical engineering to AI development",
      "Full-stack wizard with Python and JavaScript"
    ]
  },
  {
    id: 5,
    name: "Contact Station",
    theme: "contact",
    gradient: "linear-gradient(to bottom, #f43f5e, #fb7185)",
    groundColor: "#e11d48",
    description: "Let's connect and build something amazing!",
    items: [portfolioData.personal],
    npcFacts: [
      "Find Akhil on GitHub: @andromechanic",
      "Connect on LinkedIn for opportunities",
      "Ready to collaborate on amazing projects!",
      "Open to full-time roles and freelance work",
      "Building at the edge of engineering and intelligence",
      "Let's turn your ideas into AI-powered reality!"
    ]
  }
];
